import DataNotFound from "@/components/data-not-found/DataNotFound";
import Spinner from "@/components/spinner/Spinner";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import useGetApiReq from "@/hooks/useGetApiReq";
import DocumentComp from "@/partner/components/document/DocumentComp";
import ServiceUpdateComp from "@/partner/components/service-update-comp/ServiceUpdateComp";
import PartnerWrapper from "@/partner/components/wrapper/Wrapper";
import { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddDocumentModal from "@/partner/components/add-documentModal/AddDocumentModal";
import parse from "html-react-parser";
import AddServiceUpdateModal from "@/partner/components/AddServiceUpdateModal";
import usePatchApiReq from "@/hooks/usePatchApiReq";

const ClientServiceDetails = () => {
  const { res, fetchData, isLoading } = useGetApiReq();
  const {
    res: completeServiceRes,
    fetchData: fetchCompleteServiceData,
    isLoading: isCompleteServiceLoading,
  } = usePatchApiReq();

  const [client, setClient] = useState("");
  const [clientService, setClientService] = useState("");
  const [service, setService] = useState("");
  const [updates, setUpdates] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [isAddServiceUpdateModalOpen, setIsAddServiceUpdateModalOpen] =
    useState(false);

  const params = useParams();
  const { state } = useLocation();
  const icon = `${import.meta.env.VITE_IMG_URL}/${service?.icon}`;

  const getServiceDetail = async () => {
    fetchData(`/partner/purchased-service-details/${params?.serviceId}`);
  };

  useEffect(() => {
    getServiceDetail();
  }, []);

  useEffect(() => {
    if (res?.status === 200 || res?.status === 201) {
      console.log("service detail", res?.data);
      setService(res?.data?.info?.serviceInfo);
      setClient(res?.data?.info?.clientInfo);
      setClientService(res?.data?.info?.clientService);
      setUpdates(res?.data?.info?.updates);
      setDocuments(res?.data?.info?.documents);
    }
  }, [res]);

  const handleCompleteService = async () => {
    fetchCompleteServiceData(
      `/partner/update-service-status?serviceStatus=completed&serviceLinkId=${params?.serviceId}`,
    );
  };

  useEffect(() => {
    if (
      completeServiceRes?.status === 200 ||
      completeServiceRes?.status === 201
    ) {
      console.log("completeServiceRes", completeServiceRes);
      getServiceDetail();
    }
  }, [completeServiceRes]);

  const navigate = useNavigate();

  return (
    <PartnerWrapper>
      <div>
        <div className="section-heading-container">
          <h1 className="section-heading">Service Details</h1>
          <div className="flex gap-2 items-center">
            {clientService?.serviceStatus === "assigned" && (
              <Button
                className="bg-green-400 hover:bg-green-500"
                onClick={handleCompleteService}
              >
                Complete Service
              </Button>
            )}
            {state?.isShowUpdateBtn && (
              <Button onClick={() => setIsAddServiceUpdateModalOpen(true)}>
                Add Service Update
              </Button>
            )}
          </div>
        </div>
        <Table className="mt-4 glass-header !border-white !border-2">
          <TableHeader>
            <TableRow className="text-lg">
              <TableHead>Icon</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Category</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="glass-header !border-white !border-2">
              <TableCell>
                <div className="w-12 cursor-pointer h-12 rounded-full bg-slate-500">
                  <img
                    className="w-full h-full rounded-full"
                    src={icon}
                    alt=""
                  />
                </div>
              </TableCell>
              <TableCell>
                <h3 className="text-lg cursor-pointer font-semibold">
                  {service?.name}
                </h3>
              </TableCell>
              <TableCell>{service?.categoryId?.name}</TableCell>
            </TableRow>
            {/* <Service service={service} /> */}
          </TableBody>
        </Table>
        <p className="max-[560px]:text-sm">
          {service?.description && parse(service?.description)}
        </p>

        <h2 className="text-xl font-semibold mb-3 mt-14">Client Details</h2>

        <Table className="glass-header !border-white !border-2">
          <TableHeader>
            <TableRow className="text-lg">
              <TableHead>Name</TableHead>
              <TableHead>Phone</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Address</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="glass-header !border-white !border-2">
              <TableCell>{`${client?.name?.first} ${client?.name?.last}`}</TableCell>
              <TableCell>{client?.phone}</TableCell>
              <TableCell>{client.email}</TableCell>
              <TableCell>{`${client?.address?.addressLine} ${client?.address?.city}, ${client?.address?.state}, ${client?.address?.pinCode}`}</TableCell>
              <TableCell>
                <FaEye
                  onClick={() => navigate(`/partner/clients/${client?._id}`)}
                  size={24}
                  cursor={"pointer"}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <div className="flex justify-between items-center gap-3 mb-3 mt-14">
          <h2 className="text-xl font-semibold">Service Updates</h2>
          {updates.length > 0 && (
            <button
              onClick={() =>
                navigate(
                  `/partner/clients/${params?.clientId}/service/${params?.serviceId}/updates`,
                  { state: updates }
                )
              }
              className="bg-gray-800 hover:bg-gray-700 ml-2 flex gap-3 items-center text-white rounded-md px-4 py-1"
            >
              View All
            </button>
          )}
        </div>
        <Table className="mt-4 glass-header !border-white !border-2">
          <TableHeader>
            <TableRow className="text-lg">
              <TableHead>Client Name</TableHead>
              {/* <TableHead>Status</TableHead> */}
              <TableHead>Date</TableHead>
              <TableHead>Document</TableHead>
              <TableHead>Description</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading ? (
              <TableRow className="glass-header !border-white !border-2">
                <TableCell colSpan={6} className="text-center py-4">
                  Loading...
                </TableCell>
              </TableRow>
            ) : updates.length === 0 ? (
              <TableRow className="glass-header !border-white !border-2">
                <TableCell colSpan={6}>
                  <DataNotFound name={"Service Updates"} />
                </TableCell>
              </TableRow>
            ) : (
              updates?.map((update, index) => {
                if (index <= 4) {
                  return (
                    <ServiceUpdateComp
                      key={update?._id}
                      update={update}
                      getServiceUpdates={getServiceDetail}
                    />
                  );
                }
              })
            )}
          </TableBody>
        </Table>

        <div className="flex justify-between items-center gap-4 mb-3 mt-14">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-semibold">Service Documents</h2>
            {documents.length > 0 && (
              <button
                onClick={() =>
                  navigate(
                    `/partner/clients/${params?.clientId}/service/${params?.serviceId}/documents`,
                    { state: documents }
                  )
                }
                className="bg-gray-800 hover:bg-gray-700 ml-2 flex gap-3 items-center text-white rounded-md px-4 py-1"
              >
                View All
              </button>
            )}
          </div>
          <Button onClick={() => setIsAddDocumentModalOpen(true)}>
            Add Document
          </Button>
        </div>

        {documents.length === 0 && isLoading && <Spinner size={30} />}

        {documents.length === 0 && !isLoading && (
          <DataNotFound name={"Documents"} />
        )}

        <div className="grid max-[640px]:place-items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          {documents?.map((document, index) => {
            if (index <= 4) {
              return <DocumentComp key={document._id} myDocument={document} />;
            }
          })}
        </div>

        {isAddDocumentModalOpen && (
          <AddDocumentModal
            isAddDocumentModalOpen={isAddDocumentModalOpen}
            setIsAddDocumentModalOpen={setIsAddDocumentModalOpen}
            getDocuments={getServiceDetail}
            serviceId={service?._id}
          />
        )}

        {isAddServiceUpdateModalOpen && (
          <AddServiceUpdateModal
            isAddServiceUpdateModalOpen={isAddServiceUpdateModalOpen}
            setIsAddServiceUpdateModalOpen={setIsAddServiceUpdateModalOpen}
            getServiceUpdates={getServiceDetail}
            serviceId={service?._id}
            clientId={client?._id}
          />
        )}
      </div>
    </PartnerWrapper>
  );
};

export default ClientServiceDetails;
